export const roll = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_6348_6214" fill="white">
      <path d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z" />
    </mask>
    <g clipPath="url(#paint0_angular_6348_6214_clip_path)" mask="url(#path-1-inside-1_6348_6214)">
      <g transform="matrix(0 0.008 -0.008 0 8 8)">
        <foreignObject x="-1250" y="-1250" width="2500" height="2500">
          <div
            style={{
              background: 'conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(114, 92, 255, 1) 360deg)',
              height: '100%',
              width: '100%',
              opacity: 1,
            }}
          ></div>
        </foreignObject>
      </g>
    </g>
    <path
      d="M16 8H14C14 11.3137 11.3137 14 8 14V16V18C13.5228 18 18 13.5228 18 8H16ZM8 16V14C4.68629 14 2 11.3137 2 8H0H-2C-2 13.5228 2.47715 18 8 18V16ZM0 8H2C2 4.68629 4.68629 2 8 2V0V-2C2.47715 -2 -2 2.47715 -2 8H0ZM8 0V2C11.3137 2 14 4.68629 14 8H16H18C18 2.47715 13.5228 -2 8 -2V0Z"
      data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.44705882668495178,&#34;g&#34;:0.36078432202339172,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.44705882668495178,&#34;g&#34;:0.36078432202339172,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:9.7971748206813428e-16,&#34;m01&#34;:-16.0,&#34;m02&#34;:16.0,&#34;m10&#34;:16.0,&#34;m11&#34;:9.7971748206813428e-16,&#34;m12&#34;:-9.7971748206813428e-16},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
      mask="url(#path-1-inside-1_6348_6214)"
    />
    <defs>
      <clipPath id="paint0_angular_6348_6214_clip_path">
        <path
          d="M16 8H14C14 11.3137 11.3137 14 8 14V16V18C13.5228 18 18 13.5228 18 8H16ZM8 16V14C4.68629 14 2 11.3137 2 8H0H-2C-2 13.5228 2.47715 18 8 18V16ZM0 8H2C2 4.68629 4.68629 2 8 2V0V-2C2.47715 -2 -2 2.47715 -2 8H0ZM8 0V2C11.3137 2 14 4.68629 14 8H16H18C18 2.47715 13.5228 -2 8 -2V0Z"
          mask="url(#path-1-inside-1_6348_6214)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const down = (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 0.34375C4.27156 0.34375 0.84375 3.77156 0.84375 8C0.84375 12.2284 4.27156 15.6562 8.5 15.6562C12.7284 15.6562 16.1562 12.2284 16.1562 8C16.1562 3.77156 12.7284 0.34375 8.5 0.34375ZM11.5956 8.80234L8.87844 11.5197C8.86625 11.5353 8.85328 11.5505 8.83891 11.5647C8.74531 11.6583 8.62266 11.7045 8.5 11.7039C8.3775 11.7047 8.25469 11.6583 8.16109 11.5647C8.14672 11.5503 8.13359 11.5353 8.12156 11.5197L5.40438 8.8025C5.21875 8.61687 5.21875 8.31594 5.40438 8.13031C5.59 7.94469 5.89094 7.94469 6.07672 8.13031L8.02469 10.0781V4.77141C8.02469 4.50891 8.2375 4.29609 8.5 4.29609C8.7625 4.29609 8.97531 4.50891 8.97531 4.77141V10.0781L10.9234 8.13016C11.1091 7.94453 11.41 7.94453 11.5958 8.13016C11.7814 8.31578 11.7814 8.61672 11.5956 8.80234Z"
      fill="white"
    />
  </svg>
);

export const goExoirt = (
  <svg width="20" height="20" className="size-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 17.5V2.5H8.40833V4.16667H4.16667V15.8333H15.8333V11.5917H17.5V17.5H2.5ZM8.82167 10L14.655 4.16667H10.8333V2.5H17.5V9.16667H15.8333V5.345L10 11.1783L8.82167 10Z"
      fill="#0C0C0C"
    />
  </svg>
);
